import React, { useEffect, useState } from "react";
import WhiteLabelService from "../services/whitelabel";
import { toast } from "react-toastify";
import * as Sentry from "@sentry/react";
import { ProfileData } from "../common/types";
import { Avatar, Chip } from "@mui/material";

interface AccountProps {
  accountId: string;
}

function Account({ accountId }: AccountProps) {
  const [account, setAccount] = useState<ProfileData>();
  const getAccount = React.useCallback(async () => {
    const service = WhiteLabelService();
    const acc = await service.getAccount(accountId);
    setAccount(acc);
  }, [accountId]);
  //GET Account
  useEffect(() => {
    getAccount().catch((error) => {
      Sentry.setExtra("error", error);
      Sentry.captureMessage("getAccount - Error");
      toast.error("There was an error getting the account, please try again");
    });
  }, [getAccount]);
  return (
    <>
      {account && (
        <Chip
          size="small"
          className="wlr-chip"
          avatar={
            <Avatar
              alt={account.full_name}
              src={account.picture_url}
              sx={{
                height: "16px !important",
                width: "16px !important",
                marginLeft: "2px !important",
              }}
            />
          }
          label={account.full_name}
          variant="filled"
          sx={{
            backgroundColor: "#FFF",
            boxShadow: "0px 4px 6px -1px rgba(17, 24, 39, 0.06)",
            fontSize: "10px",
            lineHeight: "14px",
            height: "18px",
          }}
        />
      )}
    </>
  );
}

export default Account;
